import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ResendIcon from "assets/icon/Resend 850.svg";
import ResendIconHover from "assets/icon/Resend 850-Hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import Drawer from 'components/Drawer';
import SearchOrderDrawer from '../SearchOrder/SearchOrderDrawer';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import ViewPurchaseOrder from '../SearchOrder/ViewSearchOrder';
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import Attachments from '../PurchaseOrderAttachments';
import AddPurchaseOrder from 'components/AddPurchaseOrder'
import ProgramNotes from 'components/ProgramNotes';
import { Formik } from 'formik';
import useAxios from 'hooks/useAxios';
import EditPurchaseOrder from 'components/EditPurchaseOrder/EditPurchaseOrder';
import { ModuleAccess } from 'utils/moduleaccess';
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";



let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];

const PurchaseOrderTable = (props) => {
  
    const {
      onExport,
        manvalConfig,
        manvalPharmacy,
        data,
        totalitem,
        onPageChange,
        orgId,
        refetch,
        onSearchColumnFilters = () => "",
        filters,
        search,
        rowData,
        collapseSider,
        toggleSider,
        SelectedAccumulator,
        ceid,
        setCeid,
        resetFilterFlag,
        SetResetFilterFlag,tabKey,resetKey
    } = props;


    
    const [EditOpen, setEditOpen] = useState(false);
    const API=useAxios()
    const [tableData, setTableData] = useState(tableDataBackup);
    const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
    const [iseditflag, setiseditflag] = useState(false);
    const [drawerPODetails, setDrawerPODetails] = useState('');
    const [isOpenView, setOpenView] = useState(false);
    const [isOpenHistory, setOpenHistory] = useState(false);
    const [selectedRow, setselectedRow] = useState({});
    const [orderData, setOrderData] = useState({}); 
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [responseMessage, setResponseMessage] = useState('');
    const [selectedRowHistory, setSelectedRowHistory] = useState({});
    const [commentDrawer, setCommentDrawer] = useState(false);
    const [commentRowData, setCommentRowData] = useState({});
    const [modal, setModal] = useState(false);
    const [file, setFile] = useState(null); 
    const[filename,setfilename] = useState("");
    const [isUploading, setIsUploading] = useState(false); 
    const [uploadSuccess, setUploadSuccess] = useState(null); 
    const[poitems,setPoitems]=useState([])
    const[success,setSuccess]=useState(false)

    
  const handleFileChange = (e) => {
    
    const selectedFile = e.target.files[0]; 
    if (selectedFile) {
      setFile(selectedFile); 
    }
  };

 useEffect(() => {
  if (isOpenView) {
    setOpenView(false);
  }
  if (commentDrawer) {
    setCommentDrawer(false);
  }
  if (EditOpen) {
    setEditOpen(false);
  }
  if(modal){
    setModal(false)
  }
}, [orgId]);



  const handleFileUpload = async (e) =>{
    e.preventDefault();
    if(!file){
     return alert("please load file")
    }
    const formData = new FormData();
    formData.append("file", file);
    setfilename(file.name)
    try {
      setIsUploading(true);
      setUploadSuccess(null); 

      
      const response = await API.post(`SBTenant/${orgId.tenantID}/Comments/GetPunchoutOrderData`, formData, {
        hasDefaultURL: true,
      });

     
      setUploadSuccess(true);
      if(response.data){
        for(var x in response.data){
          response.data[x].orderLastUpdateDate = new Date();
        }
        setPoitems(response.data)
      }
      
      console.log("File uploaded successfully:", response.data);
    } catch (error) {
      setUploadSuccess(false);
      console.error("Error uploading file:", error);
    } 
   
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    const data = {
      CEID: search.AccumulatorIDs[0],
      WholesalerCode: 'McKessonPO',
      orgId :orgId.organizationID,
      PunchoutOrderItem: poitems,
      FileName: filename
    };
console.log(data,"purchase Order Data");
    try {
      const response = await API.post(`SBTenant/${orgId.tenantID}/Comments/SubmitPunchoutOrderItems`, data,
        {
          hasDefaultURL: true,
        }
      );
      console.log(response,"response");
      if(response.status=204){
        setSuccess(true)
        setResponseMessage(`Success: ${response.data.message || 'Your file has been uploaded successfully!.'}`);

      }
    } catch (error) {
    
      setResponseMessage(`Error: ${error.response ? error.response.data.message : error.message}`);
    } finally {
      setIsSubmitting(false); 
    }
  };
  

    const manvalConfigedit = (rowData) => {
      setEditOpen(!EditOpen);
      // setiseditflag(!iseditflag);
      setselectedRow(rowData);
      
}

    const toggle = () => {
      setModal(!modal);
      setPoitems([])
      setResponseMessage("")
      setSuccess(false)
      setFile(null)
    }





    const togglePODetailsDrawer = () => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('');
      };
      
    const toggleViewPODetailsDrawer = (flag) => {
        setOpenView(!isOpenView);
        if(flag){
          refetch(true);
        } 
      };
      const toggleAttachPODetailsDrawer = (rowData) => {
        setCommentDrawer(!commentDrawer);
        setCommentRowData(rowData);
        // setDrawerPODetails('');
      };
    const handleConfig = async (rowData) => {
         await manvalConfig();

    }
    const onHandleSort = (filter, hasColFilter) => {
      if (hasColFilter) {
          onPageChange(filter, true);
      } else {
          onPageChange(filter);
      }
  };
  const handleFilterCancel = () => {
    refetch(true);
};

const handleSearchColumnFilters = (colFilter) => {
  for(var x in colFilter){
    if(colFilter[x].filterName == 'totalInvoicedPrice' || colFilter[x].filterName == 'totalOrderedPrice'){
      colFilter[x].filterValue = (colFilter[x].filterValue).replace(/,/g, "")
    }
  }

  if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
  }
};
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

      if (hasColFilter) {
          const colFilterOn = { ...filter, filters: colChangedFilter };
          return onPageChange(colFilterOn, true);
      }
      onPageChange(filter);
  };


  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

      if (hasColFilter) {
          const colFilterOn = { ...filter, filters: colChangedFilter };
          onPageChange(colFilterOn, true);
      } else {
          onPageChange(filter);
      }
  };
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

   }
   const hasPermission = (code) => {
    return ModuleAccess("PCO", code);
}
    const handleEditConfig = async (rowData) => {
        await manvalConfigedit(rowData);
    }
    const authorizeorder = async (rowData) => {
      try {
        const { data } = await API.get(`SBTenant/${orgId.tenantID}/PurchaseOrder/orderauthorize/${rowData.poid}`,
          { hasDefaultURL: true, }
        )
        refetch(true);
      }

      catch {
      }
    }
    const renderEditButton = (rowData) => {
        if (hasPermission('ED'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                hidden = {rowData.poStatusID=="Order Acknowledged" ||rowData.poStatusID=="Order Invoiced" || rowData.poStatusID=="Order Authorized" ||rowData.poStatusID=="Order Consigned" ||  rowData.poStatusID=="Order Cancelled" ||rowData.poStatusID=="Order Complete" || rowData.poType == "Non-Split" || 	rowData.poType == "Split"}
                onClick={() => handleEditConfig(rowData)}
                title='Edit Order'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const renderConsignedButton = (rowData) => {
      if (hasPermission('RE'))
          return <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              //hidden = {rowData.poStatus=="Order Acknowledged" ||rowData.poStatus=="Order Invoiced" || rowData.poStatus=="Order Authorized" ||rowData.poStatus=="Order Open" ||  rowData.poStatus=="Order Cancelled" ||rowData.poStatus=="Order Complete" || rowData.poType == "Non-Split" || 	rowData.poType == "Split"}
              hidden ={rowData.poStatusID != "Order Sent"}
              onClick={() => authorizeorder(rowData)}
              title='Resend 850'

          >
              <HoverImage src={ResendIcon}
                  hoverSrc={ResendIconHover}
                  alt='' />
          </Button>
  }

    const renderConfigButton = () => {

        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleConfig()}
            title='Client Configuration'

        >
            <HoverImage
                src={ConfigIcon}
                hoverSrc={ConfigIconHover}
                alt='' />
        </Button>
    }
    const renderViewButton = (rowData) => {
      if (hasPermission('VW'))
        return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggleView(rowData)}
                title='View Order'
            >
                <HoverImage
                    key='EyeIcon'
                    src={EyeIcon}
                    hoverSrc={EyeIconHover}
                    alt=''
                />
            </Button>
        );
    };
    const toggleView = (rowData) => {
      debugger;
        setOpenView(!isOpenView);
        setselectedRow(rowData);
    };
    const renderAttachementsButton = (rowData) => {
         if (hasPermission('AT'))
            return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggleAttachPODetailsDrawer(rowData)}
                title="Attachment"
            >
                <HoverImage
                    key='AttachIcon'
                    src={AttachIcon}
                    hoverSrc={AttachHoverIcon}
                    alt=''
                />
            </Button>
            )
    }
    const toggleCommentDrawer = (rowData) => {
        setCommentDrawer((pre) => !pre);
        setCommentRowData(rowData);
    };

    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {renderViewButton(rowData)}
                {renderAttachementsButton(rowData)}
              {renderConsignedButton(rowData)}
              {renderEditButton(rowData)}

            </div>
        );
    };
  
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 120,
            show: true,
            disabled: true,
            // hideColFilter: true,
            action: true,
        },

        {
            dataField: 'poid',
            text: 'PO Number',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.poid),
        },
        {
            dataField: 'filePONumber',
            text: 'Source PO #',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.filePONumber),
        },
        {
            dataField: 'hospitalName',
            text: 'Hospital Name',
            sort: false,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.hospitalName),
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.accountType),
        },
        {
            dataField: 'accountCode',
            text: 'Acct #',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.accountCode),
        },
        {
            dataField: 'poDate',
            text: 'PO Date',
            sort: true,
            width: 120,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (row) => dateFormate(row.poDate),
        },
        {
            dataField: 'poType',
            text: 'PO Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.poType),
        
        },
        {
            dataField: 'poStatusID',
            text: 'PO Status',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.poStatusID),
        },
        {
          dataField: 'wholesalerName',
          text: 'Wholesaler Name',
          sort: false,
          width: 240,
          show: true,
          inputType: 'text',
          hideColFilter: false,
          cellRenderer: (row) => cellRendererCheck(row.wholesalerName),
      },
      {
        dataField: 'totalOrderedPrice',
        text: 'Ordered Price',
        sort: true,
        width: 150,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (row) => row.totalOrderedPrice == null ? '$0.00' : currencyFormat(row.totalOrderedPrice),
    },
    {
      dataField: 'totalInvoicedPrice',
      text: 'Invoiced Price',
      sort: true,
      width: 150,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => row .totalInvoicedPrice == null ? '$0.00' : currencyFormat(row.totalInvoicedPrice),
  },
    {
            dataField: 'createdByID',
            text: 'Created By',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.createdByID),
        },
        {
            dataField: 'modifiedByID',
            text: 'Modified By',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
        },
    ];
    let mainUploadCol = [
     

      {
          dataField: 'poUniqueId',
          text: 'PO Number',
          sort: false,
          width: 140,
          show: true,
          inputType: 'text',
          hideColFilter: true,
          cellRenderer: (row) => cellRendererCheck(row.poUniqueId),
      },
      {
          dataField: 'ndc',
          text: 'NDC',
          sort: false,
          width: 140,
          show: true,
          inputType: 'text',
          hideColFilter: true,
          cellRenderer: (row) => cellRendererCheck(row.ndc),
      },
      {
          dataField: 'ndcDescription',
          text: 'NDC Descrption',
          sort: false,
          width: 200,
          show: true,
          inputType: 'text',
          hideColFilter: true,
          cellRenderer: (row) => cellRendererCheck(row.ndcDescription),
      },
      {
          dataField: 'orderItemNumber',
          text: 'Item Number',
          sort: false,
          width: 140,
          show: true,
          inputType: 'text',
          hideColFilter: true,
          cellRenderer: (row) => cellRendererCheck(row.orderItemNumber),
      },
      {
          dataField: 'orderQty',
          text: 'QTY',
          sort: false,
          width: 140,
          show: true,
          inputType: 'text',
          hideColFilter: true,
          cellRenderer: (row) => cellRendererCheck(row.orderQty),
      },
      {
        dataField: 'orderLastUpdateDate',
        text: 'Order Date',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (row) => dateFormate(row.orderLastUpdateDate),
    },
    {
      dataField: 'custAcctId',
      text: 'Wholesaler Account Code',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.custAcctId),
  },
      

  ];

    const cellRenderLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handlePODetails(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
    const handlePODetails = (rowData) => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('OrderDetails');
        setselectedRow(rowData)
        // setPORowData(row);
      };
  return (
    <div>
       <h5 className="f-16 text-primary font-weight-700 mt-2">
            Order Count ({totalitem})
            </h5>
            <hr/>
      <div
        // className="table-card scroll-table position-relative border-0 rounded pt-0"
        // //  fixed-height={data.length > 0 ? "fixed-height" : "default"}
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          data.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="configuration-table1"
          height={550}
          fixedColumn
          width={1200}
          data={data}
          columns={mainCol}
          add={"Upload"}
          addbutton={true}
          addAccmulations={false}
          keytab={tabKey}
          buttononclick={toggle}
          hasPagination
          totalRecords={totalitem}
          onPageChange={onHandlePageChange}
          filters={filters}
           pageSize={filters.pageSize}
          currentPage={filters.currentPage}
           onExport={onExport}
          handleSort={onHandleSort}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
                showtoggle={true}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                resetKey={resetKey}
        />
      </div>
      <Drawer
        direction="end"
        title="PO Items"
        isOpen={isPODetailsOpen}
        toggle={togglePODetailsDrawer}
        size="lg"
      >
        <SearchOrderDrawer rowData={selectedRow} orgId={orgId} />
        {/* <PoReconciliationDrawerTable/> */}
      </Drawer>
      <Drawer
        direction="end"
        title="View Order"
        isOpen={isOpenView}
        toggle={toggleViewPODetailsDrawer}
        size="lg"
      >
        <ViewPurchaseOrder SelectedAccumulator={SelectedAccumulator} rowData={selectedRow} orgId={orgId} search={search} toggleViewPODetailsDrawer={toggleViewPODetailsDrawer}/>
      </Drawer>
      <Drawer
        direction="end"
        title="Add Order Attachment"
        isOpen={commentDrawer}
        toggle={toggleAttachPODetailsDrawer}
        size="lg"
      >
        <ProgramNotes orgId = {orgId} commentRowData={commentRowData}     onClose={toggleAttachPODetailsDrawer} selectedCoveredEntity={ceid}/>
      </Drawer>
      <Modal
        isOpen={modal}
        fade={false}
        toggle={toggle}
        className={props.className}
      >
        <ModalHeader toggle={toggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            McKesson Upload Order
          </h5>
        </ModalHeader>
        <ModalBody>
          <div>
            <Formik
              // initialValues={initialValues}
              // onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              // enableReinitialize={true}
              children={(props) => {
                // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                return (
                  <div hidden={""}>
                    <Row sm={5}>
                      {poitems.length == 0 ?
                        <Col md={12} lg={12} sm={12} xs={12}>
                          {" "}
                          <FormGroup>
                            <Label for="file">Choose File</Label>
                            <Input
                              id="file"
                              name="file"
                              type="file"
                              accept=".csv"
                              placeholder="Enter Contact Person Name"
                              autoComplete="off"
                              onChange={handleFileChange}
                            //value={""}
                            //component={""}
                            //onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                            />
                          </FormGroup>
                        </Col>
                        :
                        <>
                          <div
                            className='table-card scroll-table position-relative border-0 rounded pt-0 w-100 '
                            fixed-height={poitems.length > 0 ? 'fixed-height' : 'default'}
                          >
                            <ReactStrapTable

                              id="configuration-table"
                              height={250}
                              fixedColumn
                              width={133}
                              data={poitems}
                              columns={mainUploadCol}

                            />
                            {success == false ?
                              <div className='d-flex justify-content-end mt-2'>

                                <Button color="primary" className='search ' onClick={handleSubmit}>
                                <span className="right_5"><img src={save} alt="" /></span>
                                  Submit</Button>{' '}
                                <Button color="primary" className='reset' onClick={toggle}>
                                <span className="right_5"><img src={cancel} alt="" /></span>
                                  Cancel</Button>{' '}
                              </div>
                              :
                              <>
                                <div className='color-green'>{responseMessage}</div>
                                <Button color="primary" className='reset' onClick={toggle}>
                                <span className="right_5"><img src={cancel} alt="" /></span>
                                  Close</Button>

                              </>

                            }
                          </div>
                        </>

                      }
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </div>
        </ModalBody>
        {poitems.length==0?
        <ModalFooter>
          <Button color="primary" className='search' onClick={handleFileUpload} disabled={!file}>
                                        <span className="right_5"><img src={save} alt="" /></span> 
         {" "}   Load Order
          </Button>{" "}
        </ModalFooter>:""}
      </Modal>

      <Drawer
        direction="end"
        isOpen={EditOpen}
        toggle={manvalConfigedit}
        size="lg"
        title="Edit Order"
      >
        <EditPurchaseOrder
        // data={data}
        // refetch={refetch}
        SelectedAccumulator={SelectedAccumulator}
        rowData={selectedRow}
          toggle={manvalConfigedit}
          iseditflag={iseditflag}
          orgId={orgId}
          refetch={refetch}
        />
      </Drawer>
    </div>
  );
}

export default PurchaseOrderTable
